import { StarsCategories } from "../../http/server-apis";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
import { useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";




const HomeContent = () => {
  const { selectedLanguage } = useSelector((state) => state.Language);



  const [dialogOpen, setDialogOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const loaderArray = [1, 2, 3, 4, 5, 6, 7, 8];
  const navigate = useNavigate();
  const { isLoading } = useQuery(
    ["get-all-category"],
    () =>
      StarsCategories("get", {
        postfix: `?LangCode=${selectedLanguage}`,
      }),
    {
      onSuccess(data) {
        if (data?.status === 200)
          if (data.data.Status === "success")
            setCategoryList(
              data.data.Category instanceof Array ? data.data.Category : []
            );
      },
    }
  );




  return (
    <div
      data-aos="fade-zoom-in"
      data-aos-offset="200"
      data-aos-easing="ease-in-sine"
      data-aos-duration="600"
    >
      {isLoading ? (
        loaderArray.map((idx) => (
          <div
            key={idx}
            className="flex items-center gap-6 border p-2  m-2 rounded hover:bg-slate-50"
          >
            <p
              className={`w-11  h-11  rounded-sm flex items-center justify-center `}
            >
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={210}
                height={45}
              />
            </p>
            <p className="text-sm">
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={170}
                height={20}
              />
            </p>
          </div>
        ))
      ) : (
        <div className="">
          {categoryList.map((category, index) => (
            <div
              key={index}
              className="flex items-center gap-6 border p-2  m-2 border-card  rounded hover:bg-slate-50"
              onClick={() => {
                category.URL
                  ? navigate("/category-browser", { state: category })
                  : navigate(`/${category.CategoryID}`, { state: category });
              }}
            >
              <p
                style={{
                  background: category.Color,
                }}
                className={`w-11  h-[7vh]  lg:w-[3.8rem] lg:h-[3.8rem] md:w-[3rem]  rounded-sm flex items-center justify-center `}
              >
                <FontAwesomeIcon
                  icon={category.CategoryIcon}
                  color="white"
                  className="text-base lg:text-2xl md:text-xl"
                />
              </p>
              <p className="text-sm md:text-base">{category.CategoryName}</p>
            </div>
          ))}
        </div>
      )}

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      >
        <DialogContent>
        
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default HomeContent;
